import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogComponent } from "../dialog/dialog.component";
import { FormsModule } from '@angular/forms';
import { CampaignTask } from '../../models/campaignTask';
import { CampaignService } from '../../services/campaign.service';
import { Campaign } from '../../models/campaign';
import { RouterModule } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-task',
  imports: [CommonModule, DialogComponent, FormsModule, RouterModule],
  templateUrl: './task.component.html',
  styleUrl: './task.component.css'
})
export class TaskComponent {
  @Input() task!: CampaignTask;

  @Output() taskChanged = new EventEmitter<CampaignTask>();

  showTaskDialog: boolean = false;
  showDeleteSpinner: boolean = false;

  private descriptionSubject = new Subject<string>();
  private dueDateSubject = new Subject<string>();

  constructor(private campaignService: CampaignService) {
    // Set up debounced text field updates
    this.descriptionSubject.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe(value => {
      this.saveTaskField('description', value);
    });

    this.dueDateSubject.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(value => {
      this.saveTaskField('dueDate', value);
    });
  }

  taskClicked() {
    this.showTaskDialog = true;
    console.log(this.task);
  }

  // Field change handlers
  onDescriptionChange(value: string) {
    this.task.description = value;
    this.descriptionSubject.next(value);
  }

  onDueDateChange(value: string) {
    this.task.dueDate = value;
    this.dueDateSubject.next(value);
  }

  onCompleteChange(value: boolean) {
    this.task.complete = value;
    this.saveTaskField('complete', value);
  }

  onPaymentRelatedChange(value: boolean) {
    this.task.paymentRelated = value;
    this.saveTaskField('paymentRelated', value);
  }

  onCreatorFacingChange(value: boolean) {
    this.task.creatorFacing = value;
    this.saveTaskField('creatorFacing', value);
  }

  saveTaskField(fieldName: string, newValue: any) {
    if (!this.task.campaignId) {
      console.error('Cannot save task field: campaignId is missing');
      return;
    }

    // Update the task in local cache first
    this.campaignService.updateCampaignTask(this.task!);
    
    // Use patch method to update only the specific field that changed
    this.campaignService.patchCampaignTask(this.task.campaignId, this.task.id, fieldName, newValue).subscribe({
      next: () => {
        console.log(`Task ${fieldName} updated successfully`);
        this.taskChanged.emit();
      },
      error: (error) => {
        console.error(`Error updating task ${fieldName}:`, error);
      }
    });
  }

  deleteTask() {
    if (!this.task.campaignId) {
      console.error('Cannot delete task: campaignId is missing');
      return;
    }

    this.showDeleteSpinner = true;
    this.campaignService.DeleteTask(this.task.campaignId, this.task.id).subscribe({
      next: () => {
        console.log('Task deleted successfully');
        this.taskChanged.emit();
      },
      error: (error) => {
        console.error('Error deleting task:', error);
        this.showDeleteSpinner = false;
      },
      complete: () => {
        this.showTaskDialog = false;
        this.showDeleteSpinner = false;
      }
    });
  }


}
